<template>
	<li
		class="post_tile"
		@mouseover="hover = true"
		@mouseleave="hover = false"
		:class="[this.background_colour, this.mode, { featured: isFeatured() }]"
	>
		<a
			class="featured-tile inner"
			v-if="isFeatured() && isDesktop"
			:href="extractUrl(permalink)"
		>
			<div class="left">
				<div
					v-if="
						(video && video.video_url != '') ||
						(video && video.video_file != '')
					"
					class="tile-image"
					:style="{
						'--gallery-background': 'url(' + image + ')',
					}"
					:class="{
						hover: hover === true,
					}"
				>
					<video-modal
						v-if="
							(video && video.video_url != '') ||
							(video && video.video_file != '')
						"
						:has_border="'no'"
						:video_poster="image"
						:video_source="
							video.video_url || video.video_file
								? video.video_url || video.video_file.url
								: false
						"
					></video-modal>
				</div>

				<div
					class="tile-image"
					:style="{
						'--gallery-background': 'url(' + image + ')',
					}"
					:class="{
						hover: hover === true,
						fallback: !image,
					}"
				>
					<img v-if="image" :src="image" :alt="name" />
				</div>
			</div>

			<div class="right">
				<div
					class="tag_container"
					v-if="
						(tag && tag.some((e) => e.slug != 'uncategorised')) ||
						(tag && tag.some((e) => e.slug != 'all'))
					"
				>
					<h5
						v-for="(tag_item, index) in tag.filter((tag) => tag.slug !== 'all')"
						:key="index"
						:class="tag_item.slug"
						v-html="
							tag_item.name != 'Uncategorised' || tag_item.name != 'All'
								? tag_item.name
								: null
						"
					></h5>
				</div>

				<h4 v-html="name"></h4>

				<span class="subtitle" v-html="short_description"></span>

				<primary-button
					:label="'Read More'"
					:link="permalink"
					theme="dark"
				></primary-button>

				<slot></slot>
			</div>
		</a>

		<a v-else-if="!isFeatured() || !isDesktop" class="inner" :href="extractUrl(permalink)">
			<div
				class="tag_container"
				v-if="
					(tag && tag.some((e) => e.slug != 'uncategorised')) ||
					(tag && tag.some((e) => e.slug != 'all'))
				"
			>
				<h5
					v-for="(tag_item, index) in tag.filter((tag) => tag.slug !== 'all')"
					:key="index"
					:class="tag_item.slug"
					v-html="
						tag_item.name != 'Uncategorised' || tag_item.name != 'All'
							? tag_item.name
							: null
					"
				></h5>
			</div>

			<h4 v-html="name"></h4>

			<div
				v-if="
					(video && video.video_url != '') || (video && video.video_file != '')
				"
				class="tile-image"
				:style="{
					'--gallery-background': 'url(' + image + ')',
				}"
				:class="{
					hover: hover === true,
				}"
			>
				<video-modal
					v-if="
						(video && video.video_url != '') ||
						(video && video.video_file != '')
					"
					:has_border="'no'"
					:video_poster="image"
					:video_source="
						video.video_url || video.video_file
							? video.video_url || video.video_file.url
							: false
					"
				></video-modal>
			</div>

			<div
				class="tile-image"
				:style="{
					'--gallery-background': 'url(' + image + ')',
				}"
				:class="{
					hover: hover === true,
					fallback: !image,
				}"
			>
				<img v-if="image" :src="image" :alt="name" />
			</div>

			<span class="subtitle" v-html="short_description"></span>

			<primary-button
				:label="'Read More'"
				:link="permalink"
				theme="dark"
			></primary-button>

			<slot></slot>
		</a>
	</li>
</template>

<script>
import Arrow from '../../images/arrow-long.svg';
// import SecondaryButton from './SecondaryButton.vue';
import FallBack from '../../images/device.svg';
import PrimaryButton from './PrimaryButton.vue';
import VideoModal from './VideoModal.vue';

export default {
	data() {
		return {
			hover: false,
			arrow: Arrow,
			fallBack: FallBack,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		name: {},
		permalink: {},
		short_description: {},
		image: {},
		tag: {},
		background_colour: {
			default: 'light-stone',
		},
		mode: {
			default: 'news',
		},
		arrow_colour: {
			default: 'gold',
		},
		index: {},
		video: {},
		post_type: {},
	},

	computed: {
		isDesktop() {
			return this.window.width >= 1240;
		},
	},

	watch: {},

	methods: {
		toTitleCase(str) {
			return str.replace(/-/g, ' ').replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		},

		isFeatured() {
			return this.tag.some(
				(tagItem) => tagItem.name.toLowerCase() === 'featured',
			);
		},

		extractUrl(permalink) {
			if (typeof permalink === 'string') {
				// Check if it's a non-empty string
				return permalink !== '' ? permalink : null;
			} else if (typeof permalink === 'object' && permalink !== null) {
				// Check if it's an object with a 'url' property
				return permalink.url || null;
			} else {
				// Handle other cases or return a default value as needed
				return null;
			}
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		// SecondaryButton,
		VideoModal,
		PrimaryButton,
	},

	created() {},
	mounted() {
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.post_tile {
	grid-column: span 4;
	display: grid;
	position: relative;
	min-height: 400px;
	text-decoration: none;
	border: 1px solid var(--fpe-mid-grey);
	background-color: white;
	overflow: hidden;
	border-radius: 15px;
	transition: 0.2s ease all !important;
	text-decoration: none;
	position: relative;

	.site_button {
		min-width: 150px;
	}

	&:hover {
		background-color: var(--fpe-lightest-brown);
		transition: 0.2s ease all;
		border: 1px solid var(--white);

		.site_button {
			border: 1px solid var(--white);
			background-color: var(--fpe-blue);
			

			&::v-deep {
				span {
					color: var(--white);
				}
			}
		}
	}

	@media (max-width: $tablet) and (orientation: portrait) {
		grid-column: span 4;
	}

	@media (max-width: $mobile-xl) {
		grid-column: span 4;
		/* grid-template-rows: auto 1fr;
		display: flex; */
	}

	&.post,
	&.page {
		a {
			&.tile-image {
				aspect-ratio: 282 / 186;

				@media (max-width: $mobile-xl) {
					aspect-ratio: 312 / 250;
				}
			}
		}
	}

	.inner {
		text-decoration: none;
		padding: 48px 22px;

		.tag_container {
			h5 {
				margin: 0;
				font: normal normal 300 12px/14px var(--primary-font-family);
			}
		}
	}

	/* &.featured_post {
		.site_button_secondary {
			&::v-deep {
				span {
					display: none;
				}
			}
		}
	} */

	.featured-tile {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 50px;
		height: calc(100% - 96px) !important;

		.left {
			.tile-image {
				aspect-ratio: unset;
				max-width: 100%;
				/* max-height: 493px; */
				height: 100%;

				img {
					aspect-ratio: unset;
				}
			}
		}

		.right {
			padding-right: 50px;

			h4 {
				min-height: auto;
				margin-bottom: 0;
			}

			.subtitle {
				display: -webkit-box;
				-webkit-line-clamp: 8;
				line-clamp: 8;
				-webkit-box-orient: vertical;
				overflow: hidden;
			}
		}
	}

	a,
	div {
		&.tile-image {
			display: flex;
			/* aspect-ratio: 300 / 250; */
			overflow: hidden;
			transition: 0.2s ease all;
			position: relative;
			text-decoration: none;
			/* border: var(--border); */

			&.fallback {
				background: var(--cobalt);
				aspect-ratio: 281 / 159;
			}

			@media (max-width: $mobile) {
				height: auto;
			}

			.video {
				aspect-ratio: 3 / 2;
			}

			&.hover {
				img:not(.page) {
					transition: 0.2s ease all;
					transform: scale(1.1);
				}
			}

			> span {
				width: 100%;
			}

			img:not(.page) {
				width: 100%;
				height: 100%;
				object-fit: cover;
				position: relative;
				transition: 0.2s ease all;
				transform: scale(1);
				aspect-ratio: 281 / 159;
			}

			.tag_container {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				position: relative;
				z-index: 10;
				position: absolute;
				bottom: 16px;
				right: 16px;
				margin: 0;
				gap: 7px;
				justify-content: flex-end;

				h5 {
					&::v-deep {
						font: normal normal bold 11px/12px var(--primary-font-family);
					}
				}
			}
		}
	}

	h4 {
		font: normal normal 300 18px/24px var(--primary-font-family);
		margin: 24px 0 24px;
		/* min-height: 50px; */
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.subtitle {
		margin: 24px 0;
		font: normal normal 300 14px/24px var(--primary-font-family);
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;

		&::v-deep {
			p {
				margin: 0;
				font: normal normal 300 14px/24px var(--primary-font-family);
			}
		}
	}

	.content {
		padding: 24px 0;
		background-color: transparent;
		transition: 0.2s ease all;
		height: calc(100% - 48px);
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		row-gap: 24px;
		text-decoration: none;
		color: var(--midnight);
		/* border-radius: 0px 0px 15px 15px; */
		overflow: hidden;
		/* border-left: var(--border);
		border-bottom: var(--border);
		border-right: var(--border); */

		@media (max-width: $mobile-xl) {
			height: unset;
		}

		.upper {
			width: 100%;
		}

		.lower {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;

			.site_button_secondary {
				&::v-deep {
					&:hover {
						cursor: pointer;
					}
				}
			}

			.attributes {
				display: flex;
				flex-direction: row;
				align-items: center;
				gap: 5px;
				text-transform: uppercase;
			}

			a {
				color: var(--bright-blue);
			}
		}
	}

	/* &.nexty {
		.content {
			.lower {
				.site_button_secondary {
					pointer-events: none;

					&::v-deep {
						&:hover {
							cursor: unset;
							span {
								text-decoration: none;
							}
						}
					}
				}
			}
		}
	} */

	// Ensure featured tiles maintain consistent height
	&.featured {
		height: 100%;

		.featured-tile {
			height: 100%;
		}
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PostTile.vue